/*                         */
'use strict';

const log = (message, ...objects) => {
    if (window.o_global &&
        window.o_global.debug &&
        window.o_global.debug.status &&
        window.o_global.debug.status().activated === true) {
        /*                                                      */
        /*                                  */
        console.log(message, objects);
    }
};

export default {
    log
};